exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".functionsReviewTable .sphere-table-container{position:relative !important}.functionsReviewTable .k-grid-container{max-height:258px}\n", ""]);

// exports
